import Blocks from '@component/Blocks';
import PageHeader from '@component/PageHeader';

const LayoutPage = () => {
  return (
    <>
      <PageHeader />
      <Blocks />
    </>
  );
};

export default LayoutPage;
